import {FieldRelationKind} from '../../enum/field.relation.kind';
import {FieldTypeKind} from '../../enum/field.type.kind';
import {EntityMananger} from './core.entity.mananger';

export function Transient(joinEntityName?: string, relation?: FieldRelationKind, foreignKey?: string, sourceKey?: string, targetKey?: string): PropertyDecorator {
    return (target: any, key: string) => {
        const metadata = EntityMananger.getEntityColumn(target.constructor.name, key);

        metadata.columnName = key;
        metadata.columnType = FieldTypeKind.VIRTUAL;
        metadata.isForeignKey = !!joinEntityName;
        metadata.foreignKey = foreignKey;
        metadata.sourceKey = sourceKey;
        metadata.targetKey = targetKey;

        if (metadata.isForeignKey) {
            metadata.columnName = `${key}Field`;
            metadata.relation = relation;
            metadata.relationName = key;
            metadata.joinEntityName = joinEntityName;
            EntityMananger.registerEntityColumns(target.constructor.name, metadata);
        }
        return;
    };
}
